module.exports = __webpack_public_path__ + "static/img/bg.c56ae21b.png";